export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyBOArIf8N_XYZgedYrNltreI3SUZsmtuEY",
    authDomain: "pepe-40eb5.firebaseapp.com",
    databaseURL: "https://pepe-40eb5.firebaseio.com",
    projectId: "pepe-40eb5",
    storageBucket: "pepe-40eb5.appspot.com",
    messagingSenderId: "752736043873",
    appId: "1:752736043873:web:a67551f21217f9fbf17b20"
  }
};
